import { useRef, useState } from 'react';
import { Pagination, Mousewheel } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';
import Image from 'next/image';
import styles from '@features/showrooms/sections/ShowroomsSection/Components/ShowroomGallery/ShowroomGallery.styles';
import { IPointOfPresenceGalleryItem } from '@features/checkout/typescript';
import getImageQuality from '@utils/getImageQuality';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
type PropsType = {
  gallery: Array<IPointOfPresenceGalleryItem>;
};
const ShowroomGallery = ({
  gallery
}: PropsType) => {
  const swiperInstance = useRef<SwiperClass>();
  const [firstImageLoaded, setFirstImageLoaded] = useState<boolean>(false);
  const pagination = {
    clickable: true,
    renderBullet: (i: number, className: string) => `<span class="${className}" data-index="${i}"></span>`
  };
  const onLoadFirstImage = () => {
    setFirstImageLoaded(true);
  };
  return <div sx={styles.container}>
      <Swiper modules={[Pagination, Mousewheel]} pagination={pagination} onSwiper={swiper => {
      swiperInstance.current = swiper;
    }} spaceBetween={0} mousewheel>
        {gallery.slice(0, 1).map(item => <SwiperSlide key={`${item.sizes.ORGINAL}-${Math.random()}`}>
            <Image src={item.sizes.ORGINAL} alt="" onLoad={onLoadFirstImage} quality={getImageQuality()} fill />
          </SwiperSlide>)}
        {firstImageLoaded && gallery.slice(1, 9).map(item => <SwiperSlide key={`${item.sizes.ORGINAL}-${Math.random()}`}>
              <Image src={item.sizes.ORGINAL} alt="" quality={getImageQuality()} fill />
            </SwiperSlide>)}
      </Swiper>
    </div>;
};
export default ShowroomGallery;